import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { bookingListReducer } from './booking-list.reducer';
import { BOOKING_LIST_STORE_NAME, BookingListState } from './booking-list.state';

/** Token of the BookingList reducer */
export const BOOKING_LIST_REDUCER_TOKEN = new InjectionToken<ActionReducer<BookingListState, Action>>(
  'Feature BookingList Reducer'
);

/** Provide default reducer for BookingList store */
export function getDefaultBookingListReducer() {
  return bookingListReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(BOOKING_LIST_STORE_NAME, BOOKING_LIST_REDUCER_TOKEN)],
  providers: [
    {
      provide: BOOKING_LIST_REDUCER_TOKEN,
      useFactory: getDefaultBookingListReducer,
    },
  ],
})
export class BookingListStoreModule {
  public static forRoot<T extends BookingListState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<BookingListStoreModule> {
    return {
      ngModule: BookingListStoreModule,
      providers: [{ provide: BOOKING_LIST_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
